import gql from 'graphql-tag'

// Inbox Mutations

export const CREATE_INBOX = gql`
  mutation CreateInbox($name: String!) {
    messagingCreateInbox(name: $name) {
      ok
      errors
      inbox {
        id
        name
        isArchived
        channelsCount
        membersCount
      }
    }
  }
`;

export const UPDATE_INBOX = gql`
  mutation UpdateInbox($id: ID!, $name: String!) {
    messagingUpdateInbox(id: $id, name: $name) {
      ok
      errors
      inbox {
        id
        name
        isArchived
        channelsCount
        membersCount
      }
    }
  }
`;

export const ARCHIVE_INBOX = gql`
  mutation ArchiveInbox($id: ID!, $isArchived: Boolean!) {
    messagingArchiveInbox(id: $id, isArchived: $isArchived) {
      ok
      errors
      inbox {
        id
        name
        isArchived
      }
    }
  }
`;

// Channel Mutations

export const CREATE_CHANNEL = gql`
  mutation CreateChannel(
    $inboxId: ID!
    $name: String!
    $channelType: String!
    $sendAs: String!
    $twilioSid: String
    $twilioAuthToken: String
  ) {
    messagingCreateChannel(
      inboxId: $inboxId
      name: $name
      channelType: $channelType
      sendAs: $sendAs
      twilioSid: $twilioSid
      twilioAuthToken: $twilioAuthToken
    ) {
      ok
      errors
      channel {
        id
        name
        channelType
        sendAs
        isArchived
        inbox {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_CHANNEL = gql`
  mutation UpdateChannel(
    $id: ID!
    $name: String
    $sendAs: String
    $twilioSid: String
    $twilioAuthToken: String
  ) {
    messagingUpdateChannel(
      id: $id
      name: $name
      sendAs: $sendAs
      twilioSid: $twilioSid
      twilioAuthToken: $twilioAuthToken
    ) {
      ok
      errors
      channel {
        id
        name
        channelType
        sendAs
        isArchived
        inbox {
          id
          name
        }
      }
    }
  }
`;

export const ARCHIVE_CHANNEL = gql`
  mutation ArchiveChannel($id: ID!, $isArchived: Boolean!) {
    messagingArchiveChannel(id: $id, isArchived: $isArchived) {
      ok
      errors
      channel {
        id
        name
        isArchived
      }
    }
  }
`;

// Inbox Member Mutations

export const ADD_INBOX_MEMBER = gql`
  mutation AddInboxMember(
    $inboxId: ID!
    $userIds: [ID!]!
    $role: String!
    $canBeAssigned: Boolean
  ) {
    messagingAddInboxMember(
      inboxId: $inboxId
      userIds: $userIds
      role: $role
      canBeAssigned: $canBeAssigned
    ) {
      ok
      errors
    }
  }
`;

export const UPDATE_INBOX_MEMBER = gql`
  mutation UpdateInboxMember($id: ID!, $role: String, $canBeAssigned: Boolean) {
    messagingUpdateInboxMember(id: $id, role: $role, canBeAssigned: $canBeAssigned) {
      ok
      errors
      inboxMember {
        id
        role
        canBeAssigned
        user {
          id
          username
          email
        }
        inbox {
          id
          name
        }
      }
    }
  }
`;

export const REMOVE_INBOX_MEMBER = gql`
  mutation RemoveInboxMember($id: ID!) {
    messagingRemoveInboxMember(id: $id) {
      ok
      errors
    }
  }
`;

// Message Template Mutations

export const CREATE_MESSAGE_TEMPLATE = gql`
  mutation CreateMessageTemplate($title: String!, $content: String!, $shortcut: String, $isActive: Boolean) {
    messagingCreateMessageTemplate(title: $title, content: $content, shortcut: $shortcut, isActive: $isActive) {
      ok
      errors
      messageTemplate {
        id
        title
        content
        shortcut
        isActive
        dateModified
      }
    }
  }
`;

export const UPDATE_MESSAGE_TEMPLATE = gql`
  mutation UpdateMessageTemplate($id: ID!, $title: String, $content: String, $shortcut: String, $isActive: Boolean) {
    messagingUpdateMessageTemplate(id: $id, title: $title, content: $content, shortcut: $shortcut, isActive: $isActive) {
      ok
      errors
      messageTemplate {
        id
        title
        content
        shortcut
        isActive
        dateModified
      }
    }
  }
`;
